import { apiClient } from '../apiClient';

const buildSearchQueryParams = (
  text: string,
  params?: {
    categoryId?: number;
    categorySlug?: string;
    subCategoryIds?: number[];
  },
) => {
  const queryParams = new URLSearchParams();

  queryParams.append('q', text);
  queryParams.append('limit', '50');

  if (typeof params?.categoryId === 'number') {
    queryParams.append('category_id', String(params.categoryId));
  }

  if (params?.categorySlug) {
    queryParams.append('category_slug', params.categorySlug);
  }

  params?.subCategoryIds?.forEach((subCategoryId) => {
    queryParams.append('sub_category_ids[]', String(subCategoryId));
  });

  return queryParams;
};

export const getCart = async () => {
  const response = await apiClient.get('/cart');
  return response.data;
};

export const addToCart = async (
  product_id: number,
  size: string,
  _price: number,
  _discount: number,
) => {
  const response = await apiClient.post('/cart/add', {
    product_id,
    size,
  });
  return response.data;
};

export const removeFromCart = async (cart_item_id: number) => {
  const response = await apiClient.delete(`/cart/${cart_item_id}`);
  return response.data;
};

export const searchProducts = async (
  text: string,
  params?: {
    categoryId?: number;
    categorySlug?: string;
    subCategoryIds?: number[];
  },
) => {
  const queryParams = buildSearchQueryParams(text, params);
  const queryString = queryParams.toString();
  const response = await apiClient.get(
    queryString ? `/products/search?${queryString}` : '/products/search',
  );
  return response.data;
};
